<div class="time-select-wrapper">
	<div class="time-select" nz-row nzAlign="middle">
		<div nz-col nzSpan="11">
			<div class="time" nz-row nzAlign="middle">
				<input nz-col nzSpan="14" type="number" placeholder="0" [(ngModel)]="time.timeInHours"
					(ngModelChange)="updateTimeInHours()" />
				<span nz-col nzSpan="5">Hrs</span>
				<div nz-col nzSpan="5" class="control cursor-pointer">
					<div (click)="increaseTime('timeInHours')">
						<svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M4.96967 0.71967C5.26256 0.426777 5.73744 0.426777 6.03033 0.71967L10.5303 5.21967C10.8232 5.51256 10.8232 5.98744 10.5303 6.28033C10.2374 6.57322 9.76256 6.57322 9.46967 6.28033L5.5 2.31066L1.53033 6.28033C1.23744 6.57322 0.762563 6.57322 0.46967 6.28033C0.176777 5.98744 0.176777 5.51256 0.46967 5.21967L4.96967 0.71967Z"
								fill="#0B3275" fill-opacity="0.4" />
						</svg>
					</div>
					<div (click)="decreaseTime('timeInHours')">
						<svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M6.03033 6.28033C5.73744 6.57322 5.26256 6.57322 4.96967 6.28033L0.469671 1.78033C0.176777 1.48744 0.176777 1.01256 0.469671 0.719669C0.762563 0.426776 1.23744 0.426776 1.53033 0.719669L5.5 4.68934L9.46967 0.71967C9.76256 0.426777 10.2374 0.426777 10.5303 0.71967C10.8232 1.01256 10.8232 1.48744 10.5303 1.78033L6.03033 6.28033Z"
								fill="#0B3275" fill-opacity="0.4" />
						</svg>
					</div>
				</div>
			</div>
		</div>
		<div nz-col nzSpan="2">
			<span style="
                    font-size: 36px;
                    color: rgba(11, 50, 117, 0.2);
                    padding: 0 0.5rem;
                ">:</span>
		</div>
		<div nz-col nzSpan="11">
			<div class="time" nz-row nzAlign="middle">
				<input nz-col nzSpan="14" type="number" placeholder="0" [(ngModel)]="time.timeInMins"
					(ngModelChange)="updateTimeInMins()" />
				<span nz-col nzSpan="5">Mins</span>
				<div nz-col nzSpan="5" class="control cursor-pointer">
					<div (click)="increaseTime('timeInMins')">
						<svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M4.96967 0.71967C5.26256 0.426777 5.73744 0.426777 6.03033 0.71967L10.5303 5.21967C10.8232 5.51256 10.8232 5.98744 10.5303 6.28033C10.2374 6.57322 9.76256 6.57322 9.46967 6.28033L5.5 2.31066L1.53033 6.28033C1.23744 6.57322 0.762563 6.57322 0.46967 6.28033C0.176777 5.98744 0.176777 5.51256 0.46967 5.21967L4.96967 0.71967Z"
								fill="#0B3275" fill-opacity="0.4" />
						</svg>
					</div>
					<div (click)="decreaseTime('timeInMins')">
						<svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M6.03033 6.28033C5.73744 6.57322 5.26256 6.57322 4.96967 6.28033L0.469671 1.78033C0.176777 1.48744 0.176777 1.01256 0.469671 0.719669C0.762563 0.426776 1.23744 0.426776 1.53033 0.719669L5.5 4.68934L9.46967 0.71967C9.76256 0.426777 10.2374 0.426777 10.5303 0.71967C10.8232 1.01256 10.8232 1.48744 10.5303 1.78033L6.03033 6.28033Z"
								fill="#0B3275" fill-opacity="0.4" />
						</svg>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>